import api from "@/lib/api";

// Kicks off self-branded Google OAuth (our own Google Cloud client), authorization-code flow.
export async function startGoogleLogin() {
  const { data } = await api.get("/auth/google/config");
  if (!data?.client_id) throw new Error("Google sign-in is not configured yet");
  const state = Math.random().toString(36).slice(2) + Date.now().toString(36);
  sessionStorage.setItem("xurray_g_state", state);
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUri = window.location.origin + "/auth/google";
  const params = new URLSearchParams({
    response_type: "code",
    client_id: data.client_id,
    redirect_uri: redirectUri,
    scope: "openid email profile",
    state,
    prompt: "select_account",
    access_type: "online",
  });
  window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
}
